/**
 * @module lib/money
 * Utilities for parsing and formatting monetary amounts.
 * NB: The number 1 represents a single unit of the smallest denomination
 * e.g. "£1.23" is stored as 123 and NOT 1.23
 */

import exactMath from "exact-math";

/**
 * Convert a floating-poitn representation of money
 *   to our integer-based format.
 *
 * @param {number} float amount as float, e.g. 1.23
 * @returns {number} amount as integer, e.g. 123
 */
export function floatToMoney(float) {
  if (float === undefined || float === null) {
    return null;
  }
  return exactMath.mul(float, 100);
}

/**
 * Parse a string into an amount of money
 * null value will be passed straight back without parsing
 * Intended for parsing NULL-able fields in API responses
 *
 * @param {string|null} [string]
 * @returns {number|null} may be NaN if parsing failed
 */
export function stringToMoney(string) {
  if (string === null || string === "") {
    return null;
  }
  return floatToMoney(parseFloat(string));
}

/**
 * Format an amount of money as a string
 *
 * @param {number} money
 * @returns {string} money to string with 2dp, or "NaN"
 */
export function moneyToString(money) {
  // convert from pence to pounds and round to 2 d.p.
  return exactMath.div(money, 100).toFixed(2);
}



// WEBPACK FOOTER //
// ./src/lib/money/index.js